import React, { useEffect, useState } from "react";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { useLocation, useNavigate } from "react-router-dom";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import { Controller, set, useFieldArray, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import {
  formatAmount,
  parseAmount,
  UnitCollection,
} from "../../../utility/CommonFunctions";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import SearchSelectBox from "../../../components/comman/SearchSelectBox";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { Spinner } from "reactstrap";
import moment from "moment";
import PlusIcon from "../../../components/Icons/PlusIcon";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import MultiSelectDropdown from "../../../components/comman/MultiSelectDropdown";

const months = [
  { id: "Jan", name: "January" },
  { id: "Feb", name: "February" },
  { id: "Mar", name: "March" },
  { id: "Apr", name: "April" },
  { id: "May", name: "May" },
  { id: "Jun", name: "June" },
  { id: "Jul", name: "July" },
  { id: "Aug", name: "August" },
  { id: "Sep", name: "September" },
  { id: "Oct", name: "October" },
  { id: "Nov", name: "November" },
  { id: "Dec", name: "December" },
];

export default function CreateInvoice() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      invoiceItem: [
        {
          workorderItemId: "",
          hsnCode: "",
          quantity: "",
          unit: "",
          rate: "",
          taxableAmount: "",
          gst: "",
          totalAmount: "",
        },
      ],
      taxableAmount: 0,
      totalAmount: 0,
      grossAmount: 0,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "invoiceItem",
  });

  const invoiceItems = watch("invoiceItem");
  // console.log("invoiveItems========>", invoiceItems);

  const location = useLocation();
  // console.log("locationData====  =======>", location?.state?.data);

  const [existingDocuments, setExistingDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [workOrderloading, setWorkOrderLoading] = useState(false);
  const [workOrderItemsloading, setWorkOrderItemsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [deletedItemIds, setDeletedItemIds] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [state, setState] = useState({
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
    workOrder: [],
    workOrderItems: [],
    workorderId: "",
    customerId: "",
    invoiceDetail: {},
    siteId: "",
    siteName: "",
    isLoadingSite: false,
    selectedMonths: [],
    selectedMonthsIds: [],
  });

  useEffect(() => {
    if (location?.state?.data) {
      let options = {
        method: "GET",
      };
      let API =
        apiUrl?.get_invoice_detail + `?invoiceId=${location?.state?.data?.id}`;
      setState((prev) => ({
        ...prev,
        ptDataLoading: true,
      }));
      callApi(API, options).then((response) => {
        setState((prev) => ({
          ...prev,
          ptDataLoading: false,
        }));
        if (response?.status === true) {
          // console.log("res", response?.data);
          setState((prev) => ({
            ...prev,
            invoiceDetail: response?.data,
          }));
        }
      });
    }
  }, []);

  useEffect(() => {
    getAssignedSites();
  }, []);

  useEffect(() => {
    if (location?.state) {
      const formattedItems =
        state?.invoiceDetail?.invoiceitems?.map((item) => ({
          itemId: item?.id,
          workorderItemId: item?.workorderItemId || "",
          hsnCode: item?.workorderitem?.hsnCode || "",
          quantity: item?.quantity || "",
          unit: item?.workorderitem?.unit || "",
          rate: item?.workorderitem?.rate || "",
          taxableAmount: item?.taxableAmount || "",
          gst: item?.workorderitem?.gst || "",
          totalAmount: item?.totalAmount || "",
          isAuto: true,
        })) || [];

      reset({
        invoiceNumber: state?.invoiceDetail?.invoiceNumber,
        invoiceDate: moment(state?.invoiceDetail?.invoiceDate).format(
          "YYYY-MM-DD",
        ),
        siteId: state?.invoiceDetail?.workorder?.site?.id,
        taxableAmount: state?.invoiceDetail?.taxableAmount,
        gstType: state?.invoiceDetail?.workorder?.gstType,
        totalAmount: formatAmount(state?.invoiceDetail?.totalAmount),
        rententionPercentage: state?.invoiceDetail?.rententionPercentage,
        rententionAmount: formatAmount(state?.invoiceDetail?.rententionAmount),
        tdsPercentage: state?.invoiceDetail?.tdsPercentage,
        tdsAmount: formatAmount(state?.invoiceDetail?.tdsAmount),
        grossAmount: formatAmount(state?.invoiceDetail?.grossAmount),
        remark: state?.invoiceDetail?.remark,
        invoiceItem: formattedItems,
      });
      GetWorkOrderList(location?.state?.data?.workorder?.site?.id);
      GetWorkOrderItems(location?.state?.data?.workorderId);
      if (state?.invoiceDetail?.documents?.length > 0) {
        setExistingDocuments(state?.invoiceDetail?.documents);
      }
      setState((prev) => ({
        ...prev,
        siteId: state?.invoiceDetail?.workorder?.site?.id,
        siteName: state?.invoiceDetail?.workorder?.site?.name,
      }));

      // Handle month selection
      if (state?.invoiceDetail?.month) {
        let monthData = state?.invoiceDetail?.month;
        // Parse if it's a JSON string
        if (typeof monthData === "string") {
          try {
            monthData = JSON.parse(monthData);
          } catch (e) {
            console.error("Error parsing month data", e);
            monthData = [];
          }
        }

        if (Array.isArray(monthData)) {
          const selectedMonthObjs = months.filter((m) =>
            monthData.includes(m.id),
          );
          setState((prev) => ({
            ...prev,
            selectedMonths: selectedMonthObjs,
            selectedMonthsIds: monthData,
          }));
        }
      }
    }
  }, [
    state.OandMSites,
    state.assignedSites,
    state.projectSites,
    existingDocuments,
    state?.invoiceDetail,
  ]);

  useEffect(() => {
    // Calculate the sum of all `total` values
    const taxableAmount = invoiceItems?.reduce((acc, item) => {
      return acc + (parseFloat(item?.taxableAmount) || 0);
    }, 0);
    const totalAmount = invoiceItems?.reduce((acc, item) => {
      return acc + (parseFloat(item?.totalAmount) || 0);
    }, 0);

    // Update `taxableAmount`
    setValue("taxableAmount", taxableAmount);
    setValue("totalAmount", totalAmount);
  }, [invoiceItems, setValue]);

  const getAssignedSites = () => {
    const option = {
      method: "GET",
    };
    const url = `${apiUrl?.get_user_site}?pageSize=100`;
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            value: item?.site?.id,
            label: item?.site?.name,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetWorkOrderList = (id) => {
    setWorkOrderLoading(true);
    callApi(apiUrl.get_workOrder + `?siteId=${id}`).then((res) => {
      setWorkOrderLoading(false);
      if (res?.status === true) {
        setState((pre) => ({
          ...pre,
          workOrder: res?.data?.workOrder,
          ...(location?.state?.data && {
            workorderId: location?.state?.data?.workorderId,
          }),
        }));
      }
    });
  };

  const GetWorkOrderItems = (id) => {
    const option = {
      method: "GET",
    };
    setWorkOrderItemsLoading(true);
    callApi(
      apiUrl.get_work_order_item + `?from=invoice&workorderId=${id}`,
      option,
    ).then((res) => {
      setWorkOrderItemsLoading(false);
      if (res?.status === true) {
        setState((pre) => ({
          ...pre,
          workOrderItems: res?.data,
        }));
      }
    });
  };

  const totalAmount = watch("totalAmount");

  useEffect(() => {
    if (totalAmount !== undefined && totalAmount !== null) {
      handleUpdateAmountWithGst("totalAmount", parseFloat(totalAmount) || 0);
    }
  }, [totalAmount]);

  const tdsPercentage = watch("tdsPercentage");

  useEffect(() => {
    handleUpdateAmountWithGst(
      "totalAmount",
      parseFloat(watch("totalAmount")) || 0,
    );
  }, [tdsPercentage]);

  const handleUpdateAmountWithGst = (type, value) => {
    setValue(type, value);

    const taxableAmount = parseFloat(watch("taxableAmount")) || 0;
    const totalAmount = parseFloat(watch("totalAmount")) || 0;
    const retentionPercentage = parseFloat(watch("rententionPercentage")) || 0;
    const tdsPercentage = parseFloat(watch("tdsPercentage")) || 0;

    const retentionAmount = (taxableAmount * retentionPercentage) / 100;
    setValue("rententionAmount", retentionAmount.toFixed(2));

    const tdsAmount = (taxableAmount * tdsPercentage) / 100;
    setValue("tdsAmount", tdsAmount.toFixed(2));

    const grossAmount = totalAmount - tdsAmount - retentionAmount;
    setValue("grossAmount", grossAmount.toFixed(2));
  };

  const workOrderOptions = state?.workOrder?.map((item) => ({
    value: item?.id,
    label: item?.workOrderNumber,
    gstType: item?.gstType,
  }));

  // -------------- 1) When WO is picked: populate ALL items into the form --------------
  const handleChangeWO = async (wo) => {
    if (!wo?.value) return;
    setValue("gstType", wo?.gstType || "");
    setState((p) => ({ ...p, workorderId: wo.value ? wo.value : "" }));
    setWorkOrderItemsLoading(true);

    try {
      const res = await callApi(
        apiUrl.get_work_order_item + `?from=invoice&workorderId=${wo.value}`,
        { method: "GET" },
      );
      setWorkOrderItemsLoading(false);

      if (res?.status === true) {
        // save raw items to state (for lookups)
        setState((p) => ({ ...p, workOrderItems: res.data }));

        // build form rows from WO items (quantity fixed, rate editable)
        const items = res.data.map((it) => {
          const qty = Number(it.quantity ?? 0);
          const rate = Number(it.rate ?? 0);
          const gst = Number(it.gst ?? 0);
          const taxable = +(qty * rate).toFixed(2);
          const total = +(taxable * (1 + gst / 100)).toFixed(2);
          return {
            workorderItemId: it.id,
            itemName: it.item || "",
            hsnCode: it.hsnCode || "",
            quantity: qty,
            unit: it.unit || "",
            rate: rate,
            gst: gst,
            taxableAmount: taxable,
            totalAmount: total,
            isAuto: true,
          };
        });

        // preserve other form values, but replace invoiceItem array
        const current = getValues();
        const taxableSum = items.reduce(
          (s, i) => s + Number(i.taxableAmount || 0),
          0,
        );
        const totalSum = items.reduce(
          (s, i) => s + Number(i.totalAmount || 0),
          0,
        );

        reset({
          ...current,
          invoiceItem: items,
          gstType: wo?.gstType || current.gstType,
          taxableAmount: taxableSum.toFixed(2),
          totalAmount: totalSum.toFixed(2),
        });
      } else {
        toast.error(res?.message || "Unable to fetch work order items");
      }
    } catch (err) {
      setWorkOrderLoading(false);
      toast.error("Error fetching work order items");
      console.error(err);
    }
  };

  // -------------- 2) If user manually changes item (fallback) --------------
  const handleItemChange = (e, index) => {
    const selectedId = e.target.value;
    const selected = state?.workOrderItems?.find(
      (it) => String(it.id) === String(selectedId),
    );
    if (!selected) return;

    const qty = Number(
      getValues(`invoiceItem.${index}.quantity`) || selected.quantity || 0,
    );
    const rate = Number(selected.rate || 0);
    const gst = Number(selected.gst || 0);

    const taxable = +(qty * rate).toFixed(2);
    const total = +(taxable * (1 + gst / 100)).toFixed(2);

    // Update the row
    setValue(`invoiceItem.${index}.workorderItemId`, selected.id);
    setValue(`invoiceItem.${index}.hsnCode`, selected.hsnCode || "");
    setValue(`invoiceItem.${index}.unit`, selected.unit || "");
    setValue(`invoiceItem.${index}.rate`, rate);
    setValue(`invoiceItem.${index}.gst`, gst);
    setValue(`invoiceItem.${index}.quantity`, qty);
    setValue(`invoiceItem.${index}.taxableAmount`, taxable);
    setValue(`invoiceItem.${index}.totalAmount`, total);

    // Recalculate overall totals immediately
    const currentItems = getValues("invoiceItem") || [];
    const updatedItems = currentItems.map((item, i) =>
      i === index
        ? { ...item, taxableAmount: taxable, totalAmount: total }
        : item,
    );

    const taxableSum = updatedItems.reduce(
      (sum, it) => sum + Number(it.taxableAmount || 0),
      0,
    );
    const totalSum = updatedItems.reduce(
      (sum, it) => sum + Number(it.totalAmount || 0),
      0,
    );

    setValue("taxableAmount", taxableSum.toFixed(2));
    setValue("totalAmount", totalSum.toFixed(2));
  };

  // -------------- 3) When rate (or gst) changes: recalc that row and overall totals --------------
  const handleAmountChange = (index) => {
    const items = getValues("invoiceItem") || [];
    const row = items[index] || {};

    const newTaxableAmount = Number(row.taxableAmount) || 0;
    const gst = Number(row.gst) || 0;

    const woItem = state?.workOrderItems?.find(
      (it) => String(it.id) === String(row.workorderItemId),
    );
    if (!woItem) return;

    const rate = Number(woItem.rate) || 0;
    const qty = rate > 0 ? +(newTaxableAmount / rate).toFixed(4) : 0;

    const gstAmount = +(newTaxableAmount * (gst / 100)).toFixed(2);
    const total = +(newTaxableAmount + gstAmount).toFixed(2);

    setValue(`invoiceItem.${index}.quantity`, qty);
    setValue(`invoiceItem.${index}.totalAmount`, total);

    const updated = items.map((it, i) =>
      i === index
        ? {
          ...it,
          quantity: qty,
          taxableAmount: newTaxableAmount,
          totalAmount: total,
        }
        : it,
    );

    const taxableSum = updated.reduce(
      (sum, it) => sum + Number(it.taxableAmount || 0),
      0,
    );
    const totalSum = updated.reduce(
      (sum, it) => sum + Number(it.totalAmount || 0),
      0,
    );

    setValue("taxableAmount", taxableSum.toFixed(2));
    setValue("totalAmount", totalSum.toFixed(2));

    handleUpdateAmountWithGst("totalAmount", totalSum.toFixed(2));
  };

  // -------------- 4) Keep a useEffect to update overall totals when invoiceItem array changes --------------
  useEffect(() => {
    // invoiceItems is watch("invoiceItem") earlier in your code
    const taxable = (invoiceItems || []).reduce(
      (acc, item) => acc + (parseFloat(item?.taxableAmount) || 0),
      0,
    );
    const total = (invoiceItems || []).reduce(
      (acc, item) => acc + (parseFloat(item?.totalAmount) || 0),
      0,
    );
    setValue("taxableAmount", taxable.toFixed(2));
    setValue("totalAmount", total.toFixed(2));
  }, [invoiceItems, setValue]);

  const onSubmit = async (data) => {
    if (state?.selectedMonths?.length === 0) {
      toast.error("Please select at least one month");
      return;
    }
    const postData = {
      invoiceNumber: data?.invoiceNumber,
      invoiceDate: data?.invoiceDate,
      siteId: data?.siteId,
      gstType: data?.gstType,
      taxableAmount: parseAmount(data?.taxableAmount),
      totalAmount: parseAmount(data?.totalAmount),
      rententionPercentage: parseAmount(data?.rententionPercentage) || 0,
      rententionAmount: parseAmount(data?.rententionAmount) || 0,
      tdsPercentage: parseAmount(data?.tdsPercentage) || 0,
      tdsAmount: parseAmount(data?.tdsAmount) || 0,
      grossAmount: parseAmount(data?.grossAmount),
      remark: data?.remark,
      workorderId: state?.workorderId,
      month: JSON.stringify(state?.selectedMonths?.map((m) => m.id)),
    };

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });
    formData.append("invoiceItem", JSON.stringify(data?.invoiceItem));

    if (files?.length > 0) {
      files.forEach((fileObj) => {
        formData.append(fileObj?.file?.name, fileObj.file);
      });
    }

    setLoading(true);

    try {
      //delete selected items first
      if (location?.state?.data && deletedItemIds.length > 0) {
        const deletePayload = { invoiceItemId: deletedItemIds };
        const deleteRes = await callApi(apiUrl.delete_invoice_item, {
          method: "POST",
          data: deletePayload,
        });

        if (!deleteRes?.status) {
          toast.error(deleteRes?.message || "Failed to delete some items");
        } else {
          // toast.info("Deleted items removed from invoice");
        }
      }

      // invoice update or create
      const endPoint = location?.state
        ? apiUrl.update_invoice + `?invoiceId=${location?.state?.data?.id}`
        : apiUrl.create_invoice;

      const res = await callApi(endPoint, {
        method: "POST",
        form_data: formData,
      });

      setLoading(false);
      if (res?.status === true) {
        toast.success(res?.message);
        navigate(-1);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      setLoading(false);
      // console.error("Submit error:", error);
      toast.error("Something went wrong while saving invoice");
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile }, // Use file name as key
      ]);
    }
    event.target.value = ""; // Allow reselecting the same file
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName),
    );
  };

  const handleDeleteDocument = (docId) => {
    const API = `${apiUrl.delete_document}?documentId=${docId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        setExistingDocuments((prev) => prev.filter((doc) => doc.id !== docId));
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };


  const handleSearchSite = async (data = null) => {
    setState((pre) => ({ ...pre, isLoadingSite: true }));
    let API = `${apiUrl.get_user_site}?pageSize=100&search=${data}`;
    const response = await callApi(API);
    if (response?.status) {
      setState((pre) => ({
        ...pre,
        assignedSites: response?.data?.site?.map((item) => ({
          ...item,
          label: item?.site?.name,
          value: item?.site?.id,
        })),
        isLoadingSite: false,
        ...(pre.siteId ? { siteId: "" } : {}),
      }));
      setValue("siteName", "");
    }
    return response;
  };

  const handleMonthsChange = (selectedOptions) => {
    const selectedMonthsIds = selectedOptions?.map((item) => item.id) || [];
    setState((prevState) => ({
      ...prevState,
      selectedMonths: selectedOptions,
      selectedMonthsIds: selectedMonthsIds,
    }));
  };

  return (
    <>
      {workOrderItemsloading && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              type="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state ? "Edit" : "Create"} Invoice
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Invoice Number<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="bDate"
                      {...register("invoiceNumber", {
                        required: "This field is Required",
                      })}
                    />
                    {errors.invoiceNumber && (
                      <span className="form-text text-danger fs-5">
                        {errors.invoiceNumber.message}
                      </span>
                    )}
                  </div>
                </div>
                {/* Invoice Date */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Invoice Date<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="invoiceDate"
                      control={control}
                      rules={{
                        required: "Invoice date is required",
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                  </div>
                </div>

                {/* Site Selection */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      rules={{ ...errorTypes.required("site") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state?.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteId: option?.value,
                              siteName: option?.label,
                              workorderId: null,
                              workOrderItems: [],
                              workOrder: [],
                            }));
                            setValue("workorderId", null);
                            setValue("invoiceItem", []);
                            setValue("gstType", "");
                            GetWorkOrderList(option?.value);
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={state?.assignedSites}
                          onSearch={handleSearchSite}
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={
                            state?.assignedSites?.length === 0 ||
                            location?.state?.data
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Work Order<span className="text-danger">*</span>
                    </label>
                    <SearchSelectBox
                      value={state?.workorderId}
                      onChange={handleChangeWO}
                      options={workOrderOptions}
                      disable={location?.state?.data}
                      loading={workOrderloading}
                      title={
                        state?.workOrder?.length === 0
                          ? "No Work Order available"
                          : location?.state?.data
                            ? "Select Work Order"
                            : "Search Work Order"
                      }
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">GST Type</label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      disabled
                      {...register("gstType", {
                        required: "This field is required",
                      })}
                    >
                      <option value="" className="d-none"></option>
                      <option value={"IGST"}>IGST</option>
                      <option value={"CGST + SGST"}>CGST + SGST</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="Role" className="form-label">
                      Months <span className="text-danger">*</span>
                    </label>
                    <MultiSelectDropdown
                      options={months || []}
                      selectedValues={state?.selectedMonths}
                      onChange={(option) => handleMonthsChange(option)}
                      multiSelect={true}
                    />
                  </div>
                </div>

                <div className="my-3">
                  <table className="table table-bordered">
                    <thead className="table-dark">
                      <tr>
                        <th>Item</th>
                        <th>HSN</th>
                        <th>Qty</th>
                        <th>Unit</th>
                        <th>Rate</th>
                        <th>Taxable Amount</th>
                        <th>GST</th>
                        <th>Total Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fields.map((field, index) => {
                        const selectedIds = (invoiceItems || []).map(
                          (it) => it?.workorderItemId,
                        );
                        const currentSelectedId =
                          invoiceItems?.[index]?.workorderItemId;

                        return (
                          <tr key={field.id}>
                            <td style={{ minWidth: "250px" }}>
                              <select
                                {...register(
                                  `invoiceItem.${index}.workorderItemId`,
                                  {
                                    onChange: (e) => handleItemChange(e, index),
                                  },
                                )}
                                className="form-select"
                                defaultValue={currentSelectedId || ""}
                                required
                                disabled={invoiceItems?.[index]?.isAuto}
                              >
                                <option value="">Select Item</option>
                                {state?.workOrderItems?.map((item) => {
                                  const disabledOption =
                                    selectedIds.includes(item.id) &&
                                    String(item.id) !==
                                    String(currentSelectedId);
                                  return (
                                    <option
                                      key={item.id}
                                      value={item.id}
                                      disabled={disabledOption}
                                    >
                                      {item.item}
                                    </option>
                                  );
                                })}
                              </select>
                            </td>

                            <td style={{ width: "15rem" }}>
                              <input
                                {...register(`invoiceItem.${index}.hsnCode`)}
                                className="form-control"
                                type="text"
                                placeholder="HSN Code"
                                disabled
                              />
                            </td>

                            <td style={{ width: "11rem" }}>
                              <input
                                {...register(`invoiceItem.${index}.quantity`)}
                                className="form-control"
                                type="number"
                                disabled
                              />
                            </td>

                            <td style={{ minWidth: "130px" }}>
                              <select
                                {...register(`invoiceItem.${index}.unit`)}
                                className="form-select"
                                disabled
                                defaultValue={invoiceItems?.[index]?.unit || ""}
                              >
                                <option value="">Select Unit</option>
                                {UnitCollection?.map((unit, uidx) => (
                                  <option key={uidx} value={unit.value}>
                                    {unit.label}
                                  </option>
                                ))}
                              </select>
                            </td>

                            <td style={{ width: "16rem" }}>
                              <input
                                {...register(`invoiceItem.${index}.rate`, {})}
                                className="form-control"
                                type="number"
                                placeholder="Rate"
                                min={0}
                                step="0.01"
                                required
                                disabled
                                onWheel={(e) => e.currentTarget.blur()}
                              />
                            </td>

                            <td style={{ width: "15rem" }}>
                              <input
                                {...register(
                                  `invoiceItem.${index}.taxableAmount`,
                                  {
                                    onChange: () => handleAmountChange(index),
                                  },
                                )}
                                className="form-control"
                                type="number"
                                min={0}
                                step="0.01"
                                required
                                onWheel={(e) => e.currentTarget.blur()}
                              />
                            </td>

                            <td style={{ width: "9rem" }}>
                              <select
                                {...register(`invoiceItem.${index}.gst`, {})}
                                className="form-select form-control"
                                disabled
                                defaultValue={invoiceItems?.[index]?.gst ?? ""}
                              >
                                <option value="" className="d-none">
                                  GST
                                </option>
                                <option value="0">0%</option>
                                <option value="5">5%</option>
                                <option value="12">12%</option>
                                <option value="18">18%</option>
                                <option value="28">28%</option>
                              </select>
                            </td>

                            <td style={{ width: "15rem" }}>
                              <input
                                {...register(
                                  `invoiceItem.${index}.totalAmount`,
                                )}
                                className="form-control"
                                type="number"
                                disabled
                              />
                            </td>

                            <td style={{ width: "6rem" }}>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => {
                                  if (field?.itemId) {
                                    setDeletedItemIds((prev) => [
                                      ...prev,
                                      field.itemId,
                                    ]);
                                  }
                                  remove(index);
                                }}
                                disabled={fields.length === 1}
                              >
                                <DeleteIcon />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() =>
                        append({
                          workorderItemId: "",
                          hsnCode: "",
                          quantity: "",
                          unit: "",
                          rate: "",
                          taxableAmount: "",
                          gst: "",
                          totalAmount: "",
                          isAuto: false,
                        })
                      }
                      disabled={
                        state.workOrderItems?.length ===
                        (invoiceItems?.filter((item) => item?.workorderItemId)
                          .length || 0)
                      }
                    >
                      <PlusIcon />
                    </button>
                  </div>
                </div>

                <div className="row">
                  {/* Payment Details */}
                  <div className="col-12">
                    <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                      <h4 className="fs-3 rajdhani-semibold my-4 ">
                        Payment Details
                      </h4>
                    </div>
                  </div>

                  {/* Taxable Amount */}
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label className="form-label">
                          Taxable Amount<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          disabled
                          {...register("taxableAmount", {
                            required: "Taxable amount is required",
                          })}
                          onChange={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            );
                            handleUpdateAmountWithGst(
                              "taxableAmount",
                              e.target.value,
                            );
                          }}
                        />
                        {errors.taxableAmount && (
                          <span className="form-text text-danger fs-5">
                            {errors.taxableAmount.message}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Total Amount */}
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label className="form-label">
                          Total Amount<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          {...register("totalAmount", {
                            required: "Total Amount is required",
                          })}
                          disabled
                        />

                        {errors.totalAmount && (
                          <span className="form-text text-danger fs-5">
                            {errors.totalAmount.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Retention Percentage */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        Retention Percentage %{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("rententionPercentage", {
                          required: "Retention Percentage is required",
                        })}
                        defaultValue={0}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/[^0-9.]/g, "");

                          if (value.split(".").length > 2) {
                            value = value.slice(0, -1);
                          }

                          if (!/^\d{1,2}(\.\d{0,1})?$/.test(value)) {
                            value = value.slice(0, -1);
                          }

                          e.target.value = value;
                          handleUpdateAmountWithGst(
                            "rententionPercentage",
                            value,
                          );
                        }}
                      />
                      {errors.rententionPercentage && (
                        <span className="form-text text-danger fs-5">
                          {errors.rententionPercentage.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Retention Amount */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        Retention Amount<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("rententionAmount", {
                          required: "Retention Amount is required",
                        })}
                        disabled
                      />
                      {errors.rententionAmount && (
                        <span className="form-text text-danger fs-5">
                          {errors.rententionAmount.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4"></div>

                  {/* TDS Percentage */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        TDS Percentage % <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("tdsPercentage", {
                          required: "TDS Percentage is required",
                        })}
                        defaultValue={0}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/[^0-9.]/g, "");

                          if (value.split(".").length > 2) {
                            value = value.slice(0, -1);
                          }

                          if (!/^\d{1,2}(\.\d{0,1})?$/.test(value)) {
                            value = value.slice(0, -1); // Invalid character remove karega
                          }

                          e.target.value = value;
                          handleUpdateAmountWithGst(
                            "tdsPercentage",
                            e.target.value,
                          );
                        }}
                      />
                      {errors.tdsPercentage && (
                        <span className="form-text text-danger fs-5">
                          {errors.tdsPercentage.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* TDS Amount */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        TDS Amount<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("tdsAmount", {
                          required: "TDS Amount is required",
                        })}
                        disabled
                      />
                      {errors.tdsAmount && (
                        <span className="form-text text-danger fs-5">
                          {errors.tdsAmount.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12  "></div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        Gross Amount<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("grossAmount", {
                          required: "Total Amount is required",
                        })}
                        disabled
                      />
                      {errors.grossAmount && (
                        <span className="form-text text-danger fs-5">
                          {errors.grossAmount.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-12  "></div>
                  {/* File Upload */}
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label">Upload Bills</label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="documentUpload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="documentUpload"
                        role="button"
                        className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#f5f5f5",
                          borderRadius: 8,
                          minWidth: 150,
                        }}
                      >
                        <div className="d-flex flex-column">
                          <UploadPlusIcon />
                          <span className="text-muted">Choose Files</span>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="preview-section p-1 mt-3 col-lg-5">
                  {files?.length > 0 &&
                    files.map((fileObj) => (
                      <div
                        key={fileObj.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            setSelectedDocument(fileObj?.file);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{fileObj?.file?.name}</span>
                        </div>
                        <button
                          className="text-danger mx-2 bg-light"
                          onClick={() => removeFile(fileObj.key)} // Remove using file name
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}

                  {existingDocuments?.length > 0 &&
                    existingDocuments.map((doc) => (
                      <div
                        key={doc.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            const docUrl = {
                              url: doc?.url,
                            };
                            setSelectedDocument(docUrl);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{doc?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => handleDeleteDocument(doc.id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}
                </div>

                {/* Description */}
                <div className="col-12 col-md-6 col-lg-8 w-100">
                  <div className="form-group mb-3">
                    <label className="form-label">Remark</label>
                    <textarea
                      className="form-control"
                      rows={3}
                      {...register("remark")}
                    ></textarea>
                    {/* {errors.remark && <span className="form-text text-danger fs-5">{errors.remark.message}</span>} */}
                  </div>
                </div>
              </div>

              {/* Submit and Cancel Buttons */}
              <div className="d-flex align-items-center gap-3 justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary px-5"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary px-5">
                  {loading ? (
                    <Spinner />
                  ) : location?.state ? (
                    "Edit Invoice"
                  ) : (
                    "Create Invoice"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
